import { produce } from "immer";
import React, { useEffect, useContext } from "react";

import {
  Stem,
  StemGraphicHotspot,
  GraphicHotspotResponse,
} from "@examspark/types";

import QuestionContext from "../QuestionContext";

import { HotspotProps, styles } from "./common/image-map/Hotspot";
import ImageMap from "./common/image-map/ImageMap";
import Prompt from "./shared/Prompt";

const GraphicHotspot = (props: { data: StemGraphicHotspot }) => {
  const [player, dispatchPlayer] = useContext(QuestionContext);

  // Reveal Key
  useEffect(() => {
    if (player.revealKey) {
      const keys: any[] = [];
      for (const i in props.data.scoring?.spots) {
        if (props.data.scoring?.spots[i].isKey) {
          keys.push(i);
        }
      }

      dispatchPlayer({
        type: "RESPONSE",
        data: {
          id: props.data.id,
          score: true,
          response: {
            spots: keys,
          },
        },
      });
    }
  }, [player.revealKey]);

  const getMaxChoiceCount = () => {
    let maxChoices = 1;
    if (props?.data?.config?.allowMultipleKeys) {
      maxChoices = Math.max(Number(props?.data?.config?.maxChoices) || 0, 0);
    }
    return maxChoices;
  };

  const maxChoices = getMaxChoiceCount();

  // Create the hotspots
  const spots: Partial<HotspotProps>[] = produce(
    props?.data?.content?.spots || [],
    (draft) => {
      for (const spot of draft) {
        spot.props = {};

        const rsp = player?.response?.[props.data.id]?.spots;
        if (rsp && rsp.includes(spot.id)) {
          spot.props = { ...styles.selected };

          /** Score responses */
          if (player.scoreResponses) {
            spot.props = { ...styles.incorrect };
            if (props.data.scoring?.spots?.[spot.id]?.isKey) {
              spot.props = { ...styles.correct };
            }
          }
        } else {
          spot.props = styles.normal;
          if (maxChoices !== 0 && rsp && rsp.length >= maxChoices) {
            console.log("max slected!", styles.disabled);
            spot.props = styles.disabled;
          }
        }
      }
    },
  );

  console.log(spots);

  const handleSpotClick = (spot: Stem.Spot) => {
    const next = produce(
      player.response?.[props.data.id] || {},
      (draft: GraphicHotspotResponse) => {
        if (!draft.spots) {
          draft.spots = [];
        }

        const idx = draft.spots.indexOf(spot.id);
        if (idx !== -1) {
          draft.spots.splice(idx, 1);
        } else {
          if (maxChoices === 0) {
            draft.spots.push(spot.id);
          } else if (maxChoices === 1) {
            draft.spots = [spot.id];
          } else {
            if (draft.spots.length < maxChoices) {
              draft.spots.push(spot.id);
            }
          }
        }
      },
    );

    dispatchPlayer({
      type: "RESPONSE",
      data: {
        id: props.data.id,
        response: next,
      },
    });
  };

  return (
    <div className="item-player-element item-player-stem item-player-stem-graphic-hotspot">
      <Prompt data={props.data.content.prompt} />
      {props.data.content.image && (
        <ImageMap
          image={props.data.content.image}
          map={{
            areas: spots,
          }}
          onSpotClick={(spot) => {
            handleSpotClick(spot);
          }}
        />
      )}
    </div>
  );
};
export default GraphicHotspot;
